module.exports = __webpack_public_path__ + "static/media/pt.6d6fa05b.svg";